"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScheduledItem = exports.scheduledItemSchema = void 0;
var yup = require("yup");
exports.scheduledItemSchema = yup.object().shape({
    from: yup.string().required(),
    to: yup.string().required(),
    isoWeekdays: yup.array().of(yup.number()).optional(),
    startDate: yup.string().optional(),
    endDate: yup.string().optional(),
    priority: yup.number().optional(),
    restrictions: yup.array().of(yup.string()).optional(),
    platform: yup
        .array()
        .of(yup.string().oneOf(["ios", "android"]))
        .optional(),
});
function isScheduledItem(obj) {
    return exports.scheduledItemSchema.isValidSync(obj);
}
exports.isScheduledItem = isScheduledItem;
